import { ROUTE_PATH, YEARS_COMPANY } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaInputModel, SmMetaSelectModel, SmBtnMetaModel } from "common/models/utility-models/meta-model";

export class CompanyMetaModel extends FormMetaModel {
    constructor() {
      super(
        'Add Company',
        ROUTE_PATH.internshipComapny,
        ROUTE_PATH.internshipCompanyForm,
        3
      );
    }
  
    override initProperties(): any {
      const formInfo = super.initProperties();
  
      const companyName = new SmMetaInputModel(
        'companyName',
        'companyName',
        'input',
        true,
        'col-6 col-md-6',
        1,
        1,
        'Company Name',
        'text',
        '',
        false,
        true,
        true,
        false,
        50,
        1
      );
  
      const year = new SmMetaSelectModel(
        'year',
        'year',
        'select',
        true,
        'col-12 col-md-6',
        1,
        2,
        'Select Year',
        'select',
        '',
        false,
        true,
        true,
        false,
        0,
        0,
        false,
        YEARS_COMPANY,
        'name',
        'value'
      );
      // const loc = new SmMetaDynamicFormModel(
      //   'loc',
      //   'loc',
      //   'dynamicform',
      //   false,
      //   false,
      //   '',
      //   1,
      //   3,
      //   'Company Location',
      //   'addlast',
      //   {
      //     locName: new SmMetaInputModel(
      //       'locName',
      //       'locName',
      //       'input',
      //       true,
      //       'col-6 col-md-3',
      //       1,
      //       1,
      //       'Location Name',
      //       'text',
      //       '',
      //       true,
      //       true,
      //       true,
      //       false,
      //       100,
      //       1
      //     ),
      //     locAddress: new SmMetaInputModel(
      //       'locAddress',
      //       'locAddress',
      //       'input',
      //       true,
      //       'col-6 col-md-3',
      //       1,
      //       1,
      //       'Location Address ',
      //       'text',
      //       '',
      //       false,
      //       true,
      //       true,
      //       false,
      //       100,
      //       1
      //     ),
      //     internRequired: new SmMetaInputModel(
      //       'internRequired',
      //       'internRequired',
      //       'input',
      //       true,
      //       'col-6 col-md-3',
      //       1,
      //       1,
      //       'Intern Required',
      //       'number',
      //       '',
      //       false,
      //       true,
      //       true,
      //       false,
      //       3,
      //       1
      //     ),
      //   },
      //   1,
      //   true,
      //   true,
      //   true,
      //   true,
      //   [],
      //   32,
      //   true
      // );
  
      const locName = new SmMetaInputModel(
        'locName',
        'locName',
        'input',
        true,
        'col-6 col-md-3',
        1,
        1,
        'Location Name',
        'text',
        '[a-zA-Z][a-zA-Z ]+',
        false,
        true,
        true,
        false,
        100,
        1
      );
  
      const locAddress = new SmMetaInputModel(
        'locAddress',
        'locAddress',
        'input',
        true,
        'col-6 col-md-3',
        1,
        1,
        'Location Address ',
        'text',
        '',
        false,
        true,
        true,
        false,
        250,
        1
      );
  
      const internRequired = new SmMetaInputModel(
        'internRequired',
        'internRequired',
        'input',
        true,
        'col-6 col-md-3',
        1,
        1,
        'Intern Required',
        'number',
        '',
        false,
        true,
        true,
        false,
        3,
        1
      );
  
      // const mentor = new SmMetaDynamicFormModel(
      //   'mentor',
      //   'mentor',
      //   'dynamicform',
      //   false,
      //   false,
      //   '',
      //   1,
      //   4,
      //   'Mentor',
      //   'addlast',
      //   {
      //     mentorName: new SmMetaInputModel(
      //       'mentorName',
      //       'mentorName',
      //       'input',
      //       true,
      //       'col-6 col-md-4',
      //       1,
      //       1,
      //       'Mentor Name ',
      //       'text',
      //       '',
      //       false,
      //       true,
      //       true,
      //       false,
      //       100,
      //       1
      //     ),
      //     mentorEmail: new SmMetaInputModel(
      //       'mentorEmail',
      //       'mentorEmail',
      //       'input',
      //       true,
      //       'col-6 col-md-4',
      //       1,
      //       2,
      //       'Mentor E-mail ',
      //       'text',
      //       '',
      //       false,
      //       true,
      //       true,
      //       false,
      //       100,
      //       1
      //     ),
      //     mentorMobile: new SmMetaInputModel(
      //       'mentorMobile',
      //       'mentorMobile',
      //       'input',
      //       false,
      //       'col-6 col-md-4',
      //       1,
      //       3,
      //       'Mentor Mobile ',
      //       'text',
      //       '',
      //       false,
      //       true,
      //       true,
      //       false,
      //       100,
      //       1
      //     ),
      //     mentorDepartment: new SmMetaInputModel(
      //       'mentorDepartment',
      //       'mentorDepartment',
      //       'input',
      //       false,
      //       'col-6 col-md-4',
      //       1,
      //       4,
      //       'Department',
      //       'text',
      //       '',
      //       false,
      //       true,
      //       true,
      //       false,
      //       100,
      //       1
      //     ),
  
      //     mentorRole: new SmMetaInputModel(
      //       'mentorRole',
      //       'mentorRole',
      //       'input',
      //       false,
      //       'col-6 col-md-4',
      //       1,
      //       5,
      //       'Role',
      //       'text',
      //       '',
      //       false,
      //       true,
      //       true,
      //       false,
      //       100,
      //       1
      //     ),
  
      //     mentorCity: new SmMetaInputModel(
      //       'mentorCity',
      //       'mentorCity',
      //       'input',
      //       false,
      //       'col-6 col-md-4',
      //       1,
      //       6,
      //       'City',
      //       'text',
      //       '',
      //       false,
      //       true,
      //       true,
      //       false,
      //       100,
      //       1
      //     ),
      //   },
      //   5,
      //   true,
      //   true,
      //   true,
      //   true,
      //   [],
      //   32,
      //   true
      // );
  
      const mentorName = new SmMetaInputModel(
        'mentorName',
        'mentorName',
        'input',
        true,
        'col-6 col-md-4',
        1,
        1,
        'Mentor Name ',
        'text',
        '[a-zA-Z][a-zA-Z ]+',
        false,
        true,
        true,
        false,
        100,
        1
      );
      const mentorEmail = new SmMetaInputModel(
        'mentorEmail',
        'mentorEmail',
        'input',
        true,
        'col-6 col-md-4',
        1,
        2,
        'Mentor E-mail ',
        'text',
        '',
        false,
        true,
        true,
        false,
        100,
        1
      );
      const mentorMobile = new SmMetaInputModel(
        'mentorMobile',
        'mentorMobile',
        'input',
        false,
        'col-6 col-md-4',
        1,
        3,
        'Mentor Mobile ',
        'number',
        '',
        false,
        true,
        true,
        false,
        10,
        10,
      );
      const mentorDepartment = new SmMetaInputModel(
        'mentorDepartment',
        'mentorDepartment',
        'input',
        false,
        'col-6 col-md-4',
        1,
        4,
        'Department',
        'text',
        '[a-zA-Z][a-zA-Z ]+',
        false,
        true,
        true,
        false,
        100,
        1
      );
  
      const mentorRole = new SmMetaInputModel(
        'mentorRole',
        'mentorRole',
        'input',
        false,
        'col-6 col-md-4',
        1,
        5,
        'Role',
        'text',
        '[a-zA-Z][a-zA-Z ]+',
        false,
        true,
        true,
        false,
        100,
        1
      );
  
      const mentorCity = new SmMetaInputModel(
        'mentorCity',
        'mentorCity',
        'input',
        false,
        'col-6 col-md-4',
        1,
        6,
        'City',
        'text',
        '[a-zA-Z][a-zA-Z ]+',
        false,
        true,
        true,
        false,
        100,
        1
      );
  
      const buttons = {
        submit: new SmBtnMetaModel('SUBMIT', '', true, false, true, true),
        isFormControl: false,
      };
  
      return {
        formInfo,
        buttons,
        companyName,
        year,
        //loc,
        locName,
        locAddress,
        internRequired,
        // mentor,
        mentorName,
        mentorEmail,
        mentorCity,
        mentorDepartment,
        mentorRole,
        mentorMobile,
      };
    }
  }

  export class loc {
    id: '';
    internshipCompanyId: '';
    locName: '';
    locAddress: '';
    internRequired: '';
    is_delete: '';
    created: '';
    modified: '';
  }
  
  export class mentor {
    id: '';
    internshipCompanyId: '';
    mentorName: '';
    mentorEmail: '';
    mentorMobile: '';
    mentorDepartment: '';
    mentorRole: '';
    mentorCity: '';
    is_delete: '';
    created: '';
    modified: '';
  }
  
  export class postCompany {
    companyName: '';
    id?: '';
    companyLocation: []=[];
    companyMentor: []=[];
    considerYear: '';
  }